import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import CanvassBattlePlanDetailsScreen from '@/components/CanvassBattlePlanDetailsScreen';

export default function PhoneBattlePlanDetailsScreen() {
  const { battlePlanId } = useLocalSearchParams<{ battlePlanId: string }>();

  return (
    <CanvassBattlePlanDetailsScreen 
      battlePlanId={battlePlanId}
      title="Phone Campaign Lists"
      myRoutesTitle="My Phone Lists"
      noEngagementsMessage="No phone engagements found."
      showPullToRefresh={false}
    />
  );
}
